export type MfaEnforcementState = "advisory" | "blocking" | "none";

export interface MfaEnforcementSignal {
	graceDeadline?: string | null;
	mfaEnrollmentBlocking: boolean;
	mfaEnrollmentRequired: boolean;
}

const isPastDeadline = (graceDeadline: string, now: Date): boolean => {
	const deadline = new Date(graceDeadline).getTime();
	return !Number.isNaN(deadline) && deadline <= now.getTime();
};

const resolveMfaEnforcementState = (signal: MfaEnforcementSignal, now: Date = new Date()): MfaEnforcementState => {
	if (!signal.mfaEnrollmentRequired) return "none";
	if (signal.mfaEnrollmentBlocking || (signal.graceDeadline && isPastDeadline(signal.graceDeadline, now))) {
		return "blocking";
	}
	return "advisory";
};

export default resolveMfaEnforcementState;
